import Cal from "@calcom/embed-react";
import * as React from 'react';
export default {
  Cal,
  React
};